//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { NumberFormatInfo } from './NumberFormatInfo';

export class CurrencyFormatInfo extends NumberFormatInfo {
    ISOCurrencySymbol: string | null = null;
    CurrencySymbol: string | null = null;
    DecimalDigits: number = 0;
    SymbolPlaceholder: string | null = null;

    constructor(initializer?: Partial<CurrencyFormatInfo>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "CurrencyFormatInfo";
}
